'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiStarburstOutline = function TiStarburstOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.9 18.6l-3.1-2 1.7-3.4c0.2-0.5 0.2-1.1-0.1-1.5-0.2-0.5-0.7-0.8-1.3-0.9l-3.7-0.2-0.2-3.7c-0.1-0.6-0.4-1.1-0.9-1.3-0.5-0.3-1-0.3-1.5-0.1l-3.4 1.7-2-3.1c-0.6-1-2.2-1-2.8 0l-2 3.1-3.4-1.7c-0.5-0.2-1.1-0.2-1.5 0.1-0.5 0.2-0.8 0.7-0.9 1.3l-0.2 3.7-3.7 0.2c-0.6 0.1-1.1 0.4-1.3 0.9s-0.3 1-0.1 1.5l1.7 3.4-3.1 2c-0.5 0.3-0.8 0.8-0.8 1.4s0.3 1.1 0.8 1.4l3.1 2-1.7 3.4c-0.2 0.5-0.2 1.1 0.1 1.5s0.7 0.8 1.3 0.9l3.7 0.2 0.2 3.7c0.1 0.6 0.4 1.1 0.9 1.3s1 0.3 1.5 0.1l3.4-1.7 2 3.1c0.3 0.5 0.8 0.8 1.4 0.8s1.1-0.3 1.4-0.8l2-3.1 3.4 1.7c0.5 0.2 1 0.2 1.5-0.1 0.5-0.2 0.8-0.7 0.9-1.3l0.2-3.7 3.7-0.2c0.6-0.1 1.1-0.4 1.3-0.9s0.3-1 0.1-1.5l-1.7-3.4 3.1-2c0.5-0.3 0.8-0.8 0.8-1.4s-0.3-1.1-0.8-1.4z m-6.7 5l1.2 2.4-2.7 0.2c-0.8 0-1.5 0.7-1.5 1.5l-0.2 2.7-2.4-1.2c-0.7-0.4-1.7-0.1-2.1 0.6l-1.5 2.2-1.5-2.2c-0.3-0.5-0.8-0.8-1.4-0.8-0.2 0-0.5 0.1-0.7 0.2l-2.4 1.2-0.2-2.7c0-0.8-0.7-1.5-1.5-1.5l-2.7-0.2 1.2-2.4c0.4-0.7 0.1-1.7-0.6-2.1l-2.2-1.5 2.2-1.5c0.7-0.4 1-1.4 0.6-2.1l-1.2-2.4 2.7-0.2c0.8 0 1.5-0.7 1.5-1.5l0.2-2.7 2.4 1.2c0.7 0.4 1.7 0.1 2.1-0.6l1.5-2.2 1.5 2.2c0.4 0.7 1.4 1 2.1 0.6l2.4-1.2 0.2 2.7c0 0.8 0.7 1.5 1.5 1.5l2.7 0.2-1.2 2.4c-0.4 0.8-0.1 1.7 0.6 2.1l2.2 1.5-2.2 1.5c-0.7 0.4-1 1.4-0.6 2.1z' })
        )
    );
};

exports.default = TiStarburstOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/starburst-outline.js
// module id = 2208
// module chunks = 0